import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import VueMeta from 'vue-meta'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faStethoscope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTwitter, faGithub, faLinkedinIn, faGitlab, faAmazon } from '@fortawesome/free-brands-svg-icons'

import '@/assets/custom.scss'

import App from './App.vue'
import router from './router'
import store from './store'

library.add(faStethoscope)
library.add(faLinkedinIn)
library.add(faTwitter)
library.add(faAmazon)
library.add(faGithub)
library.add(faGitlab)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(BootstrapVue)
Vue.use(VueMeta)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
